import { Cross } from '@corecomponents/icons';
import { Dialog, Transition } from '@headlessui/react';
import { Typography } from '@pw-tech/omni-ui';
import { format } from 'date-fns';
import { Fragment, useState } from 'react';

export default function InstalmentModal({ isOpen, onClose, selectedPlan }: any) {
    return (
        <>

            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={onClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/40" />
                    </Transition.Child>

                    <div className="fixed inset-0 flex items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="scale-95 opacity-0"
                            enterTo="scale-100 opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="scale-100 opacity-100"
                            leaveTo="scale-95 opacity-0"
                        >
                            <Dialog.Panel className="w-full max-w-[560px] rounded-lg bg-white shadow-xl">
                                <div className="flex justify-between items-center px-6 py-2">
                                    <Dialog.Title className="text-xl font-semibold">
                                        Instalment Structure
                                    </Dialog.Title>
                                    <button onClick={onClose} className="text-xl font-bold w-6 h-6">
                                        <Cross />
                                    </button>
                                </div>
                                <hr />
                                <div className="border rounded-xl overflow-hidden my-4 mx-6">
                                    <div className="grid grid-cols-3 text-[#757575] text-sm px-4 py-2 font-medium border-b">
                                        <div>Instalment</div>
                                        <div>Due Date</div>
                                        <div className="text-right">Amount</div>
                                    </div>
                                    <div

                                        className="grid grid-cols-3 px-4 py-4 border-b"
                                    >
                                        <Typography variant='regular' weight='semi-bold'>{"Seat Booking"}</Typography>
                                        <Typography variant='regular' weight='semi-bold'>{"Now"}</Typography>
                                        <Typography variant='regular' weight='semi-bold' style={{ textAlign: 'right' }}>{selectedPlan?.partPayment?.feeDetails?.[0]?.gstPrice}</Typography>
                                    </div>
                                    {selectedPlan?.partPayment?.instalmentDetails?.map((item: any, index: number) => (
                                        <div
                                            key={index}
                                            className="grid grid-cols-3 items-center px-4 py-4 border-b"
                                        >
                                            <div className="text-[16px] text-[#3D3D3D]">{"Installment" + item?.instalmentNumber}</div>
                                            <div className='text-[16px] text-[#3D3D3D]'>{format(new Date(item?.dueDate), "dd MMM yyyy")}</div>
                                            <div className="text-[16px] text-[#3D3D3D]" style={{ textAlign: 'right' }}>{Math.ceil(item?.price)}</div>
                                        </div>
                                    ))}

                                    <div className="flex justify-between items-center px-4 py-3 bg-[#F8F8F8]">
                                        <div>
                                            <div className="font-semibold text-[#3D3D3D] text-lg">Total Fee</div>
                                            <div className="text-[10px] text-[#3D3D3D]">(Including GST)</div>
                                        </div>
                                        <div className="text-lg font-bold text-[#1B2124]">{selectedPlan?.total}</div>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
